import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Amplify, API } from 'aws-amplify';
import * as config from './aws-exports';
import 'hammerjs/hammer';
Amplify.configure(config);

// Configure Umami analytics
function configureUmami() {
  if (environment?.umami?.websiteId && environment?.umami?.apiUrl) {
    const script = document.createElement('script');
    script.id = 'umami-script';
    script.async = true;
    script.defer = true;
    script.setAttribute('data-website-id', environment.umami.websiteId);
    script.src = environment.umami.apiUrl;
    
    script.onload = () => {
      console.log('[UMAMI] Analytics initialized successfully with website ID:', environment.umami.websiteId);
    };
    
    script.onerror = () => {
      console.warn('[UMAMI] Failed to initialize analytics.');
    };

    document.head.appendChild(script);
  } else {
    console.warn('[UMAMI] Analytics configuration missing:', environment.umami);
  }
}

// Configure environment
if (environment.production) {
  enableProdMode();
}

// Initialize analytics
configureUmami();

// Bootstrap the app
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));